export default __webpack_public_path__ + "static/logo-0f7cc277ce0ca78ad79fd07f0338c1a5.png";